/**
 * GiftCardLedgerRowIcon — the small icon badge leading each ledger row
 * (BON-223), tinted by whether the entry is a credit, a debit, or a void.
 */
import { Clock, Download, Pencil, Plus, Ticket, Wallet, X } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import type { GiftCardTxnIcon } from './giftCardsModel';
import type { GiftCardTransactionType } from './giftCardTypes';

const ICON: Record<GiftCardTxnIcon, LucideIcon> = {
  download: Download,
  wallet: Wallet,
  plus: Plus,
  ticket: Ticket,
  pencil: Pencil,
  x: X,
  clock: Clock,
};

export function GiftCardLedgerRowIcon({
  icon,
  type,
  credit,
}: {
  icon: GiftCardTxnIcon;
  type: GiftCardTransactionType;
  credit: boolean;
}) {
  const Icon = ICON[icon];
  const isVoid = type === 'VOID';
  return (
    <span
      style={{
        flex: '0 0 28px',
        width: 28,
        height: 28,
        borderRadius: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: isVoid
          ? 'var(--nb-surface-2)'
          : credit
            ? 'var(--nb-primary-soft)'
            : 'var(--nb-surface)',
        color: isVoid ? 'var(--nb-ink)' : credit ? 'var(--nb-primary-2)' : 'var(--nb-muted)',
      }}
    >
      <Icon size={14} />
    </span>
  );
}
